import { render } from "./BlockComponent.vue?vue&type=template&id=6abbe966&scoped=true"
import script from "./BlockComponent.vue?vue&type=script&lang=js"
export * from "./BlockComponent.vue?vue&type=script&lang=js"

import "./BlockComponent.vue?vue&type=style&index=0&id=6abbe966&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Murilo\\Documents\\app-construp-cms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abbe966"]])

export default __exports__